import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Bell, Mail } from 'lucide-react';
import { toast } from 'sonner';

// Green checkmark SVG from Figma
const GreenCheck = () => (
  <svg width="68" height="74" viewBox="0 0 68 74" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_gc)">
      <path d="M61 3.00049L27.4429 63.0005L7 36.7607" stroke="#1F8E2A" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <filter id="filter0_d_gc" x="0" y="0" width="68.0005" height="74.0005" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="4"/>
        <feGaussianBlur stdDeviation="2"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
      </filter>
    </defs>
  </svg>
);

export default function GuestTransactionComplete() {
  const navigate = useNavigate();

  return (
    <div className="app-shell" data-testid="guest-txn-complete" style={{
      minHeight: '100vh', backgroundColor: 'var(--app-bg)',
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      position: 'relative',
    }}>
      {/* Bell icon top right */}
      <div style={{ width: '100%', maxWidth: 390, display: 'flex', justifyContent: 'flex-end', padding: '16px 20px 0' }}>
        <button style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4 }}>
          <Bell size={26} color="#000" strokeWidth={1.3} />
        </button>
      </div>

      {/* Logo */}
      <img src="/allure-logo.png" alt="Allure" style={{ width: 120, height: 107, objectFit: 'contain', marginTop: 40 }} />

      {/* Green checkmark */}
      <div style={{ marginTop: 16 }}>
        <GreenCheck />
      </div>

      {/* Transaction complete text */}
      <h2 style={{
        fontFamily: "'Inria Serif', serif", fontSize: 26, fontWeight: 700,
        color: 'var(--text)', textAlign: 'center', marginTop: 16,
      }}>
        Transaction complete!
      </h2>

      {/* Spacer */}
      <div style={{ flex: 1 }} />

      {/* Email icon */}
      <button
        onClick={() => toast.success('Receipt sent to your email!')}
        data-testid="guest-txn-email-btn"
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          marginBottom: 100, background: 'none', border: 'none', cursor: 'pointer',
          padding: 8, position: 'relative',
        }}
      >
        <Mail size={40} color="#6699CC" strokeWidth={1.5} />
        <div style={{
          position: 'absolute', bottom: -4, right: -8,
          width: 24, height: 24, borderRadius: '50%',
          backgroundColor: '#6699CC', display: 'flex',
          alignItems: 'center', justifyContent: 'center',
        }}>
          <span style={{ color: '#fff', fontSize: 14, fontWeight: 700 }}>&#x2192;</span>
        </div>
      </button>
    </div>
  );
}
